import React from "react";
import { TrackerForm } from "../../utils/types";
import moment from "moment";

export interface IEditSessionModalProps {
  formData: TrackerForm;
  day: moment.Moment;
  startTime: string;
  endTime: string;
  onSubmit: () => void;
  setStartTime: React.Dispatch<React.SetStateAction<string>>;
  setEndTime: React.Dispatch<React.SetStateAction<string>>;
  setDay: React.Dispatch<React.SetStateAction<moment.Moment>>;
  setFormData: React.Dispatch<React.SetStateAction<TrackerForm>>;
}
export const EditSessionModalContext =
  React.createContext<IEditSessionModalProps>({} as IEditSessionModalProps);
